import React from 'react'
import { Avatar, makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import seasonAvatarEmptyPreviewStyles from './seasonAvatarEmptyPreview.styles'
import DefaultOrgIcon from '../../assets/icons/DefaultOrgIcon'

const SeasonAvatarEmptyPreview = ({ croppedImage }) => {
  const useStyles = makeStyles(seasonAvatarEmptyPreviewStyles)
  const classes = useStyles()

  return croppedImage ? (
    <Avatar className={classes.preview} src={croppedImage} alt='Season-Avatar' />
  ) : (
    <DefaultOrgIcon className={classes.emptyOrg} />
  )
}

SeasonAvatarEmptyPreview.propTypes = {
  croppedImage: PropTypes.string,
}

export default SeasonAvatarEmptyPreview
